import React from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy load components
const UnpackingList = React.lazy(() => import('./pages/UnpackingList'));
const CreateUnpacking = React.lazy(() => import('./pages/CreateUnpacking'));
const UnpackingProcess = React.lazy(() => import('./pages/UnpackingProcess'));

const togUnpackingRoutes: RouteObject[] = [
  {
    path: '/tog-unpacking',
    element: <UnpackingList />,
  },
  {
    path: '/tog-unpacking/create',
    element: <CreateUnpacking />,
  },
  {
    path: '/tog-unpacking/process/:id',
    element: <UnpackingProcess />,
  },
];

export default togUnpackingRoutes;
